<template>
    <the-slidenav>
        <template slot="nav">
            <div class="w-full h-full text-white">
                <div class="p-6">
                    <laroute-link
                        :to="{ name: user ? 'dashboard.index' : 'auth.users.create' }"
                        class="w-full mb-3 shadow btn btn-blue"
                    >
                        {{ user ? 'Dashboard' : 'Create account' }}
                    </laroute-link>

                    <laroute-link
                        :to="{ name: user ? 'auth.sessions.destroy' : 'auth.sessions.create' }"
                        class="w-full mb-3 shadow btn btn-blue-lightest"
                    >
                        {{ user ? 'Logout' : 'Login' }}
                    </laroute-link>
                </div>

                <div class="w-12 h-1 mx-auto mb-6 bg-white rounded-full opacity-20" />

                <ul class="mt-4 mb-4">
                    <li>
                        <router-link
                            :to="{ name: 'listings.index' }"
                            class="sidebar-link on-white"
                            active-class="is-active"
                        >
                            Listings
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'www.pricing.index' }"
                            class="sidebar-link on-white"
                            active-class="is-active"
                        >
                            Pricing
                        </router-link>
                    </li>
                    <li>
                        <router-link
                            :to="{ name: 'www.landlords.index' }"
                            class="sidebar-link on-white"
                        >
                            For Landlords &amp; Agents
                        </router-link>

                        <ul>
                            <li>
                                <router-link
                                    :to="{ name: 'www.landlords.listings.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Property Listings
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'www.landlords.rent-collection.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Rent Collection
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'www.landlords.organisation.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Organisation
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'www.landlords.switch.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Switching Service
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <router-link
                            :to="{ name: 'www.tenants.index' }"
                            class="sidebar-link on-white"
                        >
                            For Tenants
                        </router-link>

                        <ul>
                            <li>
                                <router-link
                                    :to="{ name: 'www.tenants.payments.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Card Payments
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'www.tenants.organisation.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Organisation
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'www.tenants.listings.index' }"
                                    class="pl-10 sidebar-sublink"
                                >
                                    Find a Home
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <div class="sidebar-link hover:bg-grey-darker">
                            Learn
                        </div>

                        <ul>
                            <li>
                                <router-link
                                    :to="{ name: 'www.demos.index' }"
                                    class="pl-10 sidebar-sublink on-white"
                                    active-class="is-active"
                                >
                                    See a demo
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{ name: 'www.blog.index' }"
                                    class="pl-10 sidebar-sublink on-white"
                                    active-class="is-active"
                                >
                                    Blog
                                </router-link>
                            </li>
                            <li>
                                <a
                                    href="https://help.rentora.co.uk/"
                                    class="flex items-center pl-10 sidebar-sublink on-white"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    Help Center

                                    <base-svg
                                        name="icon-external-window"
                                        class="w-4 h-4 ml-2 fill-primary-white fill-secondary-white"
                                    />
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </template>

        <template
            slot="body"
            slot-scope="{
                toggle: toggleSlidenav,
                isOpen: is_slidenav_open
            }"
        >
            <div
                class="relative w-full overflow-x-hidden bg-center bg-no-repeat"
                :class="bg_class"
                :style="bg_style"
            >
                <div class="w-full bg-blue h-1-5" />

                <nav class="container relative z-10 flex items-center max-w-3xl p-6 mx-auto lg:py-12">
                    <button
                        type="button"
                        class="block focus:outline-none lg:hidden"
                        @click.prevent="toggleSlidenav"
                    >
                        <base-svg
                            :key="is_slidenav_open ? 'icon-close' : 'icon-menu'"
                            :name="is_slidenav_open ? 'icon-close' : 'icon-menu'"
                            class="w-6 h-6 fill-primary-blue focus:outline-none"
                        />
                    </button>

                    <div class="flex-grow h-5 mr-6 text-center sm:h-6 lg:flex-none md:mr-0">
                        <router-link
                            :to="{ name: 'www.home.index' }"
                            class="inline-block h-full"
                        >
                            <base-svg
                                name="logo-rentora"
                                class="h-full fill-primary-blue"
                            />
                        </router-link>
                    </div>

                    <div class="flex-grow hidden ml-6 lg:flex">
                        <router-link
                            :to="{ name: 'listings.index' }"
                            class="ml-3 btn btn-transparent btn-sm"
                        >
                            Listings
                        </router-link>

                        <router-link
                            :to="{ name: 'www.pricing.index' }"
                            class="ml-3 btn btn-transparent btn-sm"
                        >
                            Pricing
                        </router-link>

                        <base-dropdown
                            placement="bottom-start"
                            :close-on-route="true"
                            class="ml-3"
                        >
                            <button
                                slot="trigger"
                                slot-scope="{
                                    toggle: toggleLearn,
                                    is_open: is_learn_open,
                                }"
                                :class="{ 'is-active': is_learn_open }"
                                class="flex items-center btn btn-transparent btn-sm btn-with-icon"
                                type="button"
                                @click.prevent="toggleLearn"
                            >
                                Features
                                <base-svg
                                    :key="is_learn_open ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                                    :name="is_learn_open ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                                    class="w-6 h-6"
                                />
                            </button>

                            <div
                                slot="menu"
                                class="w-64 py-3 text-white rounded shadow-lg bg-grey-darker mt-3px"
                            >
                                <ul>
                                    <li>
                                        <router-link
                                            :to="{ name: 'www.landlords.index' }"
                                            class="sidebar-link"
                                        >
                                            For Landlords &amp; Agents
                                        </router-link>

                                        <ul>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.landlords.listings.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Property Listings
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.landlords.rent-collection.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Rent Collection
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.landlords.organisation.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Organisation
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.landlords.switch.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Switching Service
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <router-link
                                            :to="{ name: 'www.tenants.index' }"
                                            class="sidebar-link"
                                        >
                                            For Tenants
                                        </router-link>

                                        <ul>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.tenants.payments.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Card Payments
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.tenants.organisation.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Organisation
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link
                                                    :to="{ name: 'www.tenants.listings.index' }"
                                                    class="pl-8 sidebar-sublink"
                                                >
                                                    Find a Home
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>
                               </ul>
                            </div>
                        </base-dropdown>

                        <base-dropdown
                            placement="bottom-start"
                            :close-on-route="true"
                            class="ml-3"
                        >
                            <button
                                slot="trigger"
                                slot-scope="{
                                    toggle: toggleLearn,
                                    is_open: is_learn_open,
                                }"
                                :class="{ 'is-active': is_learn_open }"
                                class="flex items-center btn btn-transparent btn-sm btn-with-icon"
                                type="button"
                                @click.prevent="toggleLearn"
                            >
                                Learn
                                <base-svg
                                    :key="is_learn_open ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                                    :name="is_learn_open ? 'icon-cheveron-up' : 'icon-cheveron-down'"
                                    class="w-6 h-6"
                                />
                            </button>

                            <div
                                slot="menu"
                                class="w-64 py-3 text-white rounded shadow-lg bg-grey-darker mt-3px"
                            >
                                <ul>
                                    <li>
                                        <router-link
                                            :to="{ name: 'www.demos.index' }"
                                            class="sidebar-link"
                                        >
                                            See a demo
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link
                                            :to="{ name: 'www.blog.index' }"
                                            class="sidebar-link"
                                        >
                                            Blog
                                        </router-link>
                                    </li>
                                    <li>
                                        <a
                                            href="https://help.rentora.co.uk/"
                                            class="flex items-center sidebar-link"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            Help Center

                                            <base-svg
                                                name="icon-external-window"
                                                class="w-4 h-4 ml-2"
                                            />
                                        </a>
                                    </li>
                               </ul>
                            </div>
                        </base-dropdown>
                    </div>

                    <div class="hidden ml-6 lg:flex">
                        <laroute-link
                            :to="{ name: user ? 'auth.sessions.destroy' : 'auth.sessions.create' }"
                            class="shadow btn btn-white text-blue"
                        >
                            {{ user ? 'Logout' : 'Login' }}
                        </laroute-link>

                        <laroute-link
                            :to="{ name: user ? 'dashboard.index' : 'auth.users.create' }"
                            class="ml-3 shadow-md btn btn-blue"
                        >
                            {{ user ? 'Dashboard' : 'Create account' }}
                        </laroute-link>
                    </div>
                </nav>

                <router-view />

                <footer class="py-6 pb-24 text-white bg-blue-bg-darker md:py-12">
                    <div class="container max-w-3xl mx-auto">
                        <grid-layout class="mb-6 md:mb-24">
                            <grid-layout-item class="mb-12 lg:mb-0 xs:w-1/2 lg:w-1/4">
                                <h6 class="mb-4 text-lg font-bold">Product</h6>

                                <ul class="font-semibold text-blue-lightest">
                                    <li class="mb-2">
                                        <router-link
                                            :to="{ name: 'listings.index' }"
                                            class="hover:text-white"
                                        >
                                            Listings
                                        </router-link>
                                    </li>

                                    <li class="mb-2">
                                        <router-link
                                            :to="{ name: 'www.pricing.index' }"
                                            class="hover:text-white"
                                        >
                                            Pricing
                                        </router-link>
                                    </li>

                                    <li class="mb-2">
                                        <router-link
                                            :to="{ name: 'www.landlords.index' }"
                                            class="hover:text-white"
                                        >
                                            For Landlords
                                        </router-link>
                                    </li>

                                    <li class="mb-2">
                                        <router-link
                                            :to="{ name: 'www.tenants.index' }"
                                            class="hover:text-white"
                                        >
                                            For Tenants
                                        </router-link>
                                    </li>
                                </ul>
                            </grid-layout-item>

                            <grid-layout-item class="mb-12 lg:mb-0 xs:w-1/2 lg:w-1/4">
                                <h6 class="mb-4 text-lg font-bold">Resources</h6>

                                <ul class="font-semibold text-blue-lightest">
                                    <li class="mb-2">
                                        <router-link
                                            :to="{ name: 'www.demos.index' }"
                                            class="hover:text-white"
                                        >
                                            See a demo
                                        </router-link>
                                    </li>
                                    <li class="mb-2">
                                        <a
                                            href="https://help.rentora.co.uk/"
                                            class="flex items-center hover:text-white"
                                            target="_blank"
                                            rel="noopener"
                                        >
                                            Help Center

                                            <base-svg
                                                name="icon-external-window"
                                                class="w-4 h-4 ml-2 fill-primary-white fill-secondary-white"
                                            />
                                        </a>
                                    </li>

                                    <li
                                        v-if="false"
                                        class="mb-2"
                                    >
                                        <router-link
                                            :to="{ path: '#' }"
                                            class="hover:text-white"
                                        >
                                            Templates &amp; files
                                        </router-link>
                                    </li>
                                </ul>
                            </grid-layout-item>

                            <grid-layout-item class="mb-12 lg:mb-0 xs:w-1/2 lg:w-1/4">
                                <h6 class="mb-4 text-lg font-bold">Company</h6>

                                <ul class="font-semibold text-blue-lightest">
                                    <li
                                        v-if="false"
                                        class="mb-2"
                                    >
                                        <router-link
                                            :to="{ path: '#' }"
                                            class="hover:text-white"
                                        >
                                            About
                                        </router-link>
                                    </li>

                                    <li
                                        v-if="false"
                                        class="mb-2"
                                    >
                                        <router-link
                                            :to="{ path: '#' }"
                                            class="hover:text-white"
                                        >
                                            Press
                                        </router-link>
                                    </li>

                                    <li class="mb-2">
                                        <router-link
                                            :to="{ name: 'www.contact.index' }"
                                            class="hover:text-white"
                                        >
                                            Contact us
                                        </router-link>
                                    </li>

                                    <li
                                        v-if="false"
                                        class="mb-2"
                                    >
                                        <router-link
                                            :to="{ path: '#' }"
                                            class="hover:text-white"
                                        >
                                            Careers
                                        </router-link>
                                    </li>
                                </ul>
                            </grid-layout-item>

                            <grid-layout-item class="lg:mb-0 xs:w-1/2 lg:w-1/4">
                                <h6 class="mb-4 text-lg font-bold">Connect</h6>

                                <ul class="font-semibold text-blue-lightest">
                                    <li class="mb-2">
                                        <a
                                            href="https://www.facebook.com/rentorauk"
                                            class="hover:text-white"
                                        >
                                            Facebook
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a
                                            href="https://twitter.com/rentorauk"
                                            class="hover:text-white"
                                        >
                                            Twitter
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a
                                            href="https://www.instagram.com/rentorauk"
                                            class="hover:text-white"
                                        >
                                            Instagram
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a
                                            href="https://www.youtube.com/channel/UC8cr7tbs4iIXTx7L30-IdjQ"
                                            class="hover:text-white"
                                        >
                                            YouTube
                                        </a>
                                    </li>
                                </ul>
                            </grid-layout-item>
                        </grid-layout>

                        <div class="flex flex-col items-center justify-center pb-6 text-xs text-blue-lighter">
                            <div class="flex-none px-3">
                                <router-link :to="{ name: 'www.policies.terms.index' }">
                                    Terms,
                                </router-link>

                                <router-link :to="{ name: 'www.policies.privacy.index' }">
                                    Privacy
                                </router-link>

                                &amp;

                                <router-link :to="{ name: 'www.policies.cookies.index' }">
                                    Cookie
                                </router-link>

                                policies
                            </div>

                            <div class="flex-none px-3">
                                &copy; {{ $moment().format('Y') }} Tenant Manager Ltd.
                            </div>
                        </div>
                    </div>
                </footer>

                <the-request-callback-notice />
            </div>
        </template>
    </the-slidenav>
</template>

<script>
    import _ from 'lodash'
    import * as types from '../store/types'
    import TheRequestCallbackNotice from './the-request-callback-notice'
    import TheSlidenav from './the-slidenav'

    export default {
        components: {
            TheRequestCallbackNotice,
            TheSlidenav
        },
        computed: {
            bg_class () {
                if (_.has(this.$route, 'meta.the-layout-www.bg_class')) {
                    return _.get(this.$route, 'meta.the-layout-www.bg_class')
                }

                switch (_.get(this.$route, 'meta.the-layout-www.bg')) {
                    case 'hero-background-blue-bg':
                        return 'bg-blue-bg'
                }

                switch (this.$route.name) {
                    case 'listings.index':
                    case 'www.demos.index':
                    case 'www.landlords.listings.index':
                    case 'www.landlords.organisation.index':
                    case 'www.landlords.rent-collection.index':
                    case 'www.pricing.index':
                    case 'www.tenants.listings.index':
                    case 'www.tenants.organisation.index':
                    case 'www.tenants.payments.index':
                        return 'bg-blue-bg'
                }

                return 'bg-white'
            },
            bg_style () {
                if (_.has(this.$route, 'meta.the-layout-www.bg_style')) {
                    return _.get(this.$route, 'meta.the-layout-www.bg_style')
                }

                switch (_.get(this.$route, 'meta.the-layout-www.bg')) {
                    case 'hero-background-white':
                        return {
                            'background-image': 'url(/img/hero-background.svg)',
                            'background-position': 'top -20px center',
                            'background-size': '1747px 912px'
                        }
                    case 'hero-background-blue-bg':
                        return {
                            'background-image': 'url(/img/hero-background-dark.svg)',
                            'background-position': 'top -20px center',
                            'background-size': '1747px 912px'
                        }
                }

                switch (this.$route.name) {
                    case 'listings.show':
                    case 'www.blog.index':
                    case 'www.blog.show':
                    case 'www.home.index':
                    case 'www.landlords.index':
                    case 'www.tenants.index':
                        return {
                            'background-image': 'url(/img/hero-background.svg)',
                            'background-position': 'top -20px center',
                            'background-size': '1747px 912px'
                        }
                    case 'listings.index':
                    case 'www.demos.index':
                    case 'www.landlords.listings.index':
                    case 'www.landlords.organisation.index':
                    case 'www.landlords.rent-collection.index':
                    case 'www.pricing.index':
                    case 'www.tenants.listings.index':
                    case 'www.tenants.organisation.index':
                    case 'www.tenants.payments.index':
                        return {
                            'background-image': 'url(/img/hero-background-dark.svg)',
                            'background-position': 'top -20px center',
                            'background-size': '1747px 912px'
                        }
                }

                return {}
            },
            contact_tel () {
                return _.preload('contact.telephone', 'n/a')
            },
            contact_email () {
                return _.preload('contact.email', 'n/a')
            },
            user () {
                return _.get(this.$store.getters[types.users.modules.current.getters.item], 'data')
            }
        }
    }
</script>
